import { render } from "./SimpleFooter.vue?vue&type=template&id=57679b92&scoped=true"
import script from "./SimpleFooter.vue?vue&type=script&lang=js"
export * from "./SimpleFooter.vue?vue&type=script&lang=js"

import "./SimpleFooter.vue?vue&type=style&index=0&id=57679b92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57679b92"]])

export default __exports__